import { push } from 'connected-react-router'
import { HOME } from 'constant'

export const navigateHome = () => push(HOME)
